import { useEffect, useRef } from 'react'
import { Button, Fa, Modal } from '@eltoro-ui/components'
import { useNavigate } from 'react-router-dom'
import { trackEvent } from 'Hooks/usePostHog'
import aupPDF from '../../Assets/Legal/Acceptable Use Policy.pdf'
import './AUPPage.scss'

const DOCUMENT_TYPE = 'acceptable_usage_policy'
const DOCUMENT_VERSION = '1.0'
const PORTAL = 'gen3'

export const AUPPage = () => {
  const navigate = useNavigate()
  const viewTracked = useRef(false)
  const downloadInFlight = useRef(false)

  useEffect(() => {
    if (viewTracked.current) return
    viewTracked.current = true
    trackEvent('legal_document_viewed', {
      document_type: DOCUMENT_TYPE,
      document_version: DOCUMENT_VERSION,
      portal: PORTAL,
    })
  }, [])

  const handleClose = () => {
    if (window.history.state && window.history.state.idx > 0) navigate(-1)
    else navigate('/')
  }

  const handleDownloadPDF = () => {
    if (downloadInFlight.current) return
    downloadInFlight.current = true
    trackEvent('legal_document_downloaded', {
      document_type: DOCUMENT_TYPE,
      document_version: DOCUMENT_VERSION,
      portal: PORTAL,
    })

    const a = document.createElement('a')
    a.href = aupPDF
    a.download = 'el_toro_acceptable_use_policy.pdf'
    document.body.appendChild(a)
    a.style.display = 'none'
    a.click()
    document.body.removeChild(a)

    setTimeout(() => {
      downloadInFlight.current = false
    }, 500)
  }

  return (
    <Modal
      offClick={handleClose}
      header={<p>Acceptable Use Policy</p>}
      className="AUPPage__modal min-w-[80%]"
      classNameContent="AUPPage__modal-content"
    >
      <div className="AUPPage flex h-full flex-col">
        <div className="AUPPage__iframe-container relative m-auto h-full w-full flex-1">
          <iframe
            src={`${aupPDF}#view=FitH&toolbar=0&navpanes=0`}
            title="El Toro Acceptable Use Policy"
            className="AUPPage__pdf-container h-full w-full"
          >
            <p>
              This browser does not support PDFs. Please download the Acceptable
              Use Policy using the button below.
            </p>
          </iframe>
        </div>
        <div className="AUPPage__footer sticky bottom-0 flex flex-col py-3">
          <div className="flex flex-wrap justify-between">
            <span
              aria-label="Download a copy of the acceptable use policy"
              data-tooltip="right"
            >
              <Button
                onClick={handleDownloadPDF}
                iconLeft={<Fa icon="file-arrow-down" size={1} />}
              >
                Download PDF
              </Button>
            </span>
          </div>
        </div>
      </div>
    </Modal>
  )
}
